module.exports = __webpack_public_path__ + "static/media/spring.3f863f8b.png";